import React from "react";
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

/**
 * 
 * @param {any} props
 */
const Table = (props) => {
    let resultadoTablero = props.propiedadInstancia?.length > 0 ?
    <table className="table table-striped bottom-separator-xs VistaInstanciaParametroTableScroll">
        <TableHeader entidadInstancia={props.entidadInstancia} propiedadesHeaderGrilla={props.propiedadesHeaderGrilla}/>
        <TableBody propiedadInstancia={props.propiedadInstancia}
            entidadInstancia={props.entidadInstancia}
            setearEntidadInstancia={props.setearEntidadInstancia}
            cantidadRegistrosEntidad={props.cantidadRegistrosEntidad}
            soloLectura={props.soloLectura} />
    </table>
    :
    <div className="VistaInstanciaParametro-SinResultados">No se encontraron resultados</div>

    return (
        resultadoTablero
    );
}

export default Table